module.exports = __webpack_public_path__ + "img/world.3389a3fd.png";